<template>
  <div class="page-card">
    <el-card>
      <div slot="header">用户管理</div>
      <el-form :inline="true" size="small" @submit.native.prevent>
        <el-form-item label="手机号">
          <el-input v-model="query.phone" placeholder="手机号" />
        </el-form-item>
        <el-form-item label="车牌号">
          <el-input
            v-model="query.licensePlate"
            placeholder="车牌号"
            @input="onQueryLicensePlateInput"
          />
        </el-form-item>
        <el-form-item label="会员等级">
          <el-select v-model="query.level" clearable placeholder="全部">
            <el-option label="普通会员" value="普通会员" />
            <el-option label="黄金会员" value="黄金会员" />
            <el-option label="钻石会员" value="钻石会员" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchList">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="success" icon="el-icon-download" @click="exportUsers(false)">导出当前查询</el-button>
          <el-button type="success" icon="el-icon-download" @click="exportAllUsers">全部导出</el-button>
          <el-button
            type="success"
            plain
            icon="el-icon-download"
            :disabled="!selectedRows.length"
            @click="exportUsers(true)"
          >导出已勾选</el-button>
          <el-button type="warning" icon="el-icon-upload2" @click="importVisible = true">积分批量导入</el-button>
          <el-button
            type="danger"
            plain
            icon="el-icon-delete"
            :disabled="!selectedRows.length"
            @click="batchDeleteUsers"
          >批量删除</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="list"
        border
        stripe
        @selection-change="onSelectionChange"
      >
        <el-table-column type="selection" width="48" />
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="phone" label="手机号" />
        <el-table-column prop="licensePlate" label="车牌号" />
        <el-table-column prop="name" label="姓名" />
        <el-table-column prop="nickname" label="昵称" />
        <el-table-column prop="level" label="会员等级" />
        <el-table-column prop="points" label="积分" />
        <el-table-column prop="status" label="状态" />
        <el-table-column label="操作" width="340">
          <template slot-scope="scope">
            <el-button size="mini" @click="viewDetail(scope.row)">详情</el-button>
            <el-button size="mini" @click="changeLevel(scope.row)">调整等级</el-button>
            <el-button size="mini" @click="changePoints(scope.row)">调整积分</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="toggleStatus(scope.row)"
            >
              {{ scope.row.status === '正常' ? '冻结' : '解冻' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="text-align:right;margin-top:16px;">
        <el-pagination
          layout="prev, pager, next, total"
          :total="total"
          :page-size="query.pageSize"
          :current-page.sync="query.page"
          @current-change="fetchList"
        />
      </div>

      <el-dialog
        title="用户详情"
        :visible.sync="detailVisible"
        width="800px"
      >
        <template v-if="currentUser">
          <el-descriptions :column="2" size="small">
            <el-descriptions-item label="ID">{{ currentUser.id }}</el-descriptions-item>
            <el-descriptions-item label="会员等级">{{ currentUser.level }}</el-descriptions-item>
            <el-descriptions-item label="积分">{{ currentUser.points }}</el-descriptions-item>
            <el-descriptions-item label="状态">{{ currentUser.status }}</el-descriptions-item>
          </el-descriptions>
          <el-form :model="detailForm" label-width="88px" size="small" style="margin-top:12px;max-width:520px;">
            <el-form-item label="手机号">
              <el-input v-model="detailForm.phone" maxlength="11" show-word-limit placeholder="手机号" />
            </el-form-item>
            <el-form-item label="车牌号">
              <el-input
                v-model="detailForm.licensePlate"
                maxlength="20"
                clearable
                placeholder="可留空"
                @input="onDetailLicensePlateInput"
              />
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="detailForm.name" maxlength="50" clearable placeholder="姓名" />
            </el-form-item>
            <el-form-item label="昵称">
              <el-input v-model="detailForm.nickname" maxlength="50" clearable placeholder="昵称" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="detailSaving" @click="saveDetailProfile">保存资料</el-button>
            </el-form-item>
          </el-form>
        </template>
        <el-divider>持有优惠券</el-divider>
        <el-table
          :data="currentUserCoupons"
          size="small"
          border
        >
          <el-table-column prop="name" label="名称" />
          <el-table-column prop="category" label="类型" />
          <el-table-column prop="price" label="面额" />
          <el-table-column prop="discount" label="折扣" />
          <el-table-column prop="expireDate" label="有效期至" />
          <el-table-column prop="status" label="状态" />
        </el-table>
      </el-dialog>

      <el-dialog
        title="调整会员等级"
        :visible.sync="levelDialogVisible"
        width="360px"
      >
        <el-form :model="levelForm" label-width="80px">
          <el-form-item label="会员等级">
            <el-select v-model="levelForm.level" placeholder="请选择等级" style="width: 100%;">
              <el-option label="普通会员" value="普通会员" />
              <el-option label="黄金会员" value="黄金会员" />
              <el-option label="钻石会员" value="钻石会员" />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="levelDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitLevel">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="积分批量导入"
        :visible.sync="importVisible"
        width="720px"
      >
        <div style="margin-top:12px;">
          <el-button size="mini" @click="downloadImportTemplate">下载模板</el-button>
        </div>
        <el-upload
          style="margin-top:12px;"
          action=""
          :auto-upload="false"
          :show-file-list="true"
          :limit="1"
          :before-upload="beforeImportFile"
          :on-change="onImportFileChange"
        >
          <el-button type="primary">选择文件</el-button>
        </el-upload>
        <div style="margin-top:12px;">
          <el-form label-width="120px" size="small">
          </el-form>
        </div>
        <el-divider />
        <div style="display:flex;justify-content:space-between;align-items:center;">
          <div style="color:#606266;font-size:13px;">
            待导入：{{ importRows.length }} 行
            <span v-if="importErrors.length" style="color:#F56C6C;margin-left:10px;">解析错误：{{ importErrors.length }} 行</span>
          </div>
          <div>
            <el-button @click="resetImport">清空</el-button>
            <el-button type="primary" :loading="importing" :disabled="!importRows.length" @click="runImport">开始导入</el-button>
          </div>
        </div>
        <el-progress
          v-if="importing"
          style="margin-top:10px;"
          :percentage="importProgress"
          :status="importProgress >= 100 ? 'success' : 'active'"
        />
        <div v-if="importResultLines.length" style="margin-top:12px;max-height:240px;overflow:auto;background:#0b1020;color:#cbd5e1;padding:10px;border-radius:6px;font-family:ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;font-size:12px;">
          <div v-for="(line, idx) in importResultLines" :key="idx">{{ line }}</div>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '@/api/request'
import * as XLSX from 'xlsx'

export default {
  name: 'UserList',
  data() {
    return {
      query: {
        phone: '',
        licensePlate: '',
        level: '',
        page: 1,
        pageSize: 10
      },
      list: [],
      total: 0,
      selectedRows: [],
      detailVisible: false,
      currentUser: null,
      currentUserCoupons: [],
      detailForm: {
        phone: '',
        licensePlate: '',
        name: '',
        nickname: ''
      },
      detailSaving: false,
      levelDialogVisible: false,
      levelForm: {
        id: null,
        level: ''
      },

      // 批量导入积分
      importVisible: false,
      importFile: null,
      importMatchKey: 'smart', // 固定：phone → id → licensePlate
      importRows: [],
      importErrors: [],
      importing: false,
      importProgress: 0,
      importResultLines: []
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    normalizeLicensePlate(value) {
      return String(value || '')
        .toUpperCase()
        .replace(/[^\u4E00-\u9FA5A-Z0-9·]/g, '')
    },
    onQueryLicensePlateInput(value) {
      const next = this.normalizeLicensePlate(value)
      if (next !== this.query.licensePlate) this.query.licensePlate = next
    },
    onDetailLicensePlateInput(value) {
      const next = this.normalizeLicensePlate(value)
      if (next !== this.detailForm.licensePlate) this.detailForm.licensePlate = next
    },
    onSelectionChange(rows) {
      this.selectedRows = Array.isArray(rows) ? rows : []
    },
    fetchList() {
      const normalizedPlate = this.normalizeLicensePlate(this.query.licensePlate)
      if (normalizedPlate !== this.query.licensePlate) this.query.licensePlate = normalizedPlate
      request
        .get('/users', { params: this.query })
        .then(res => {
          const data = res.data || res
          this.list = (data && data.items) || []
          this.total = (data && data.total) || 0
        })
    },
    resetQuery() {
      this.query.phone = ''
      this.query.licensePlate = ''
      this.query.level = ''
      this.query.page = 1
      this.fetchList()
    },
    changePoints(row) {
      this.$prompt('请输入积分变动值（如 +100 或 -50），或直接输入最终积分（如 500）', '调整积分', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '+100 / -50 / 500',
        inputPattern: /^\s*[-+]?\d+\s*$/,
        inputErrorMessage: '请输入整数'
      })
        .then(({ value }) => {
          const v = String(value || '').trim()
          let payload = {}
          if (!v) {
            this.$message.warning('输入不能为空')
            return
          }
          if (v.startsWith('+') || v.startsWith('-')) {
            payload = { delta: parseInt(v, 10) }
          } else {
            payload = { points: parseInt(v, 10) }
          }
          request.put(`/users/${row.id}/points`, payload).then(() => {
            this.$message.success('积分已更新')
            this.fetchList()
          })
        })
        .catch(() => {})
    },
    viewDetail(row) {
      request.get(`/users/${row.id}`).then(res => {
        const data = res.data || res
        this.currentUser = data.user
        this.currentUserCoupons = data.coupons || []
        this.detailForm = {
          phone: (data.user && data.user.phone) || '',
          licensePlate: (data.user && data.user.licensePlate) || '',
          name: (data.user && data.user.name) || '',
          nickname: (data.user && data.user.nickname) || ''
        }
        this.detailVisible = true
      })
    },
    saveDetailProfile() {
      if (!this.currentUser || !this.currentUser.id) return
      const phone = String(this.detailForm.phone || '').trim()
      if (!phone) {
        this.$message.warning('手机号不能为空')
        return
      }
      this.detailSaving = true
      const normalizedPlate = this.normalizeLicensePlate(this.detailForm.licensePlate).trim()
      if (normalizedPlate !== this.detailForm.licensePlate) this.detailForm.licensePlate = normalizedPlate
      request
        .post(`/users/${this.currentUser.id}/contact`, {
          phone,
          licensePlate: normalizedPlate,
          name: String(this.detailForm.name || '').trim(),
          nickname: String(this.detailForm.nickname || '').trim()
        })
        .then(res => {
          const d = res.data || res
          const u = d.user || {}
          this.currentUser = { ...this.currentUser, ...u }
          this.detailForm.phone = this.currentUser.phone || ''
          this.detailForm.licensePlate = this.currentUser.licensePlate || ''
          this.detailForm.name = this.currentUser.name || ''
          this.detailForm.nickname = this.currentUser.nickname || ''
          this.$message.success(res.msg || res.message || '保存成功')
          this.fetchList()
        })
        .finally(() => {
          this.detailSaving = false
        })
    },
    batchDeleteUsers() {
      const rows = this.selectedRows || []
      if (!rows.length) {
        this.$message.warning('请先勾选要删除的用户')
        return
      }
      const ids = rows.map(r => r.id)
      this.$confirm(
        `将永久删除选中的 ${ids.length} 个用户及其优惠券、打卡、消费等相关数据，且不可恢复。确认继续？`,
        '批量删除',
        { type: 'warning', confirmButtonText: '确定删除', cancelButtonText: '取消' }
      )
        .then(() =>
          request.post('/users/batch-delete', { ids }).then(res => {
            const d = res.data || res
            const deleted = (d && d.deleted) != null ? d.deleted : ids.length
            const missing = (d && d.missingIds) || []
            if (missing.length) {
              this.$message.warning(`已删除 ${deleted} 个；以下 ID 不存在或未删除：${missing.join(', ')}`)
            } else {
              this.$message.success(res.msg || res.message || `已删除 ${deleted} 个用户`)
            }
            this.fetchList()
          })
        )
        .catch(() => {})
    },
    changeLevel(row) {
      this.levelForm = {
        id: row.id,
        level: row.level || '普通会员'
      }
      this.levelDialogVisible = true
    },
    submitLevel() {
      if (!this.levelForm.id || !this.levelForm.level) {
        this.$message.warning('请选择会员等级')
        return
      }
      request
        .put(`/users/${this.levelForm.id}/level`, { level: this.levelForm.level })
        .then(() => {
          this.$message.success('调整成功')
          this.levelDialogVisible = false
          this.fetchList()
        })
    },
    toggleStatus(row) {
      const target = row.status === '正常' ? '冻结' : '正常'
      this.$confirm(`确认将该账号状态调整为【${target}】吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        request.put(`/users/${row.id}/status`, { status: target }).then(() => {
          this.$message.success('操作成功')
          this.fetchList()
        })
      })
    },

    // -------------------------
    // 批量导出
    // -------------------------
    exportUsers(onlySelected) {
      const rows = onlySelected ? (this.selectedRows || []) : null
      if (onlySelected && (!rows || !rows.length)) {
        this.$message.warning('请先勾选要导出的用户')
        return
      }
      if (onlySelected) {
        this.downloadCsv(`users_selected_${Date.now()}.csv`, this.usersToCsv(rows))
        return
      }
      // 导出当前查询：分页拉取全部（最多 5000 行，防止误导出过大）
      this.$confirm('将导出当前筛选条件下的全部用户（最多 5000 条）。确认继续？', '提示', { type: 'warning' })
        .then(() => this.fetchAllUsersForExport())
        .then(all => {
          this.downloadCsv(`users_export_${Date.now()}.csv`, this.usersToCsv(all))
        })
        .catch(() => {})
    },
    exportAllUsers() {
      this.$confirm('将忽略当前筛选条件并导出全部用户（最多 5000 条）。确认继续？', '提示', { type: 'warning' })
        .then(() => this.fetchAllUsersForExport({ ignoreQuery: true }))
        .then(all => {
          this.downloadCsv(`users_export_all_${Date.now()}.csv`, this.usersToCsv(all))
        })
        .catch(() => {})
    },
    async fetchAllUsersForExport(options = {}) {
      const max = 5000
      const pageSize = 200
      const ignoreQuery = !!options.ignoreQuery
      const baseQuery = ignoreQuery
        ? {
            phone: '',
            licensePlate: '',
            level: '',
            page: 1,
            pageSize
          }
        : { ...this.query, page: 1, pageSize }
      const out = []
      let page = 1
      while (out.length < max) {
        const q = { ...baseQuery, page }
        // eslint-disable-next-line no-await-in-loop
        const res = await request.get('/users', { params: q })
        const data = res.data || res
        const items = (data && data.items) || []
        if (!items.length) break
        out.push(...items)
        if (items.length < pageSize) break
        page += 1
      }
      return out.slice(0, max)
    },
    usersToCsv(rows) {
      const safe = (v) => {
        const s = v == null ? '' : String(v)
        // 防 CSV 注入：以 = + - @ 开头的值前置 '
        const t = /^[=+\-@]/.test(s) ? `'${s}` : s
        // 包含逗号/换行/引号则整体包引号，并转义引号
        if (/[,"\r\n]/.test(t)) return `"${t.replace(/"/g, '""')}"`
        return t
      }
      const header = ['id', 'phone', 'licensePlate', 'name', 'nickname', 'level', 'points', 'status']
      const lines = [header.join(',')]
      ;(rows || []).forEach(r => {
        lines.push([
          safe(r.id),
          safe(r.phone),
          safe(r.licensePlate),
          safe(r.name),
          safe(r.nickname),
          safe(r.level),
          safe(r.points),
          safe(r.status)
        ].join(','))
      })
      return lines.join('\r\n')
    },
    downloadCsv(filename, csvText) {
      const blob = new Blob(['\ufeff' + String(csvText || '')], { type: 'text/csv;charset=utf-8;' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },

    // -------------------------
    // 批量导入积分
    // -------------------------
    async downloadImportTemplate() {
      try {
        const users = await this.fetchAllUsersForExport({ ignoreQuery: true })
        const header = [
          'id',
          'phone',
          'licensePlate',
          'name',
          'nickname',
          'currentPoints',
          'increasePoints',
          'decreasePoints',
          'finalPoints'
        ]
        const rows = [header]
        ;(users || []).forEach(u => {
          rows.push([
            u.id == null ? '' : u.id,
            u.phone == null ? '' : u.phone,
            u.licensePlate == null ? '' : u.licensePlate,
            u.name == null ? '' : u.name,
            u.nickname == null ? '' : u.nickname,
            u.points == null ? 0 : u.points,
            '', // increasePoints
            '', // decreasePoints
            '' // finalPoints
          ])
        })
        const ws = XLSX.utils.aoa_to_sheet(rows)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'points_import')
        const tips = [
          ['积分导入模板说明'],
          ['1) id / phone / licensePlate 三个定位字段，至少填写一个（建议优先填写 id）。'],
          ['2) currentPoints：导出时的当前积分；若未填 finalPoints 且未填增减列，则按该值写入为最终积分。'],
          ['3) increasePoints（或简写 increase）填本次增加的积分（非负整数）。'],
          ['4) decreasePoints（或简写 decrease）填本次减少的积分（非负整数）。'],
          ['5) finalPoints 可不填；若填写则优先作为最终积分。'],
          ['6) 填写了 increase/decrease 任一列时按「当前积分 + 增 - 减」；否则仅用 currentPoints/finalPoints。'],
          ['7) 请勿修改数据页（points_import）的表头名称。']
        ]
        const tipsWs = XLSX.utils.aoa_to_sheet(tips)
        XLSX.utils.book_append_sheet(wb, tipsWs, '说明')
        XLSX.writeFile(wb, 'points_import_template.xlsx')
      } catch (e) {
        this.$message.error('下载模板失败，请重试')
      }
    },
    resetImport() {
      this.importFile = null
      this.importRows = []
      this.importErrors = []
      this.importing = false
      this.importProgress = 0
      this.importResultLines = []
    },
    beforeImportFile(file) {
      const name = (file && file.name) ? String(file.name) : ''
      if (!/\.(xlsx|csv)$/i.test(name)) {
        this.$message.warning('目前仅支持 Excel/CSV 文件（.xlsx / .csv）')
        return false
      }
      return true
    },
    onImportFileChange(file) {
      const raw = file && (file.raw || file)
      if (!raw) return
      this.importFile = raw
      this.parseImportFile(raw)
    },
    async parseImportFile(file) {
      this.importRows = []
      this.importErrors = []
      this.importResultLines = []
      try {
        const name = String((file && file.name) || '').toLowerCase()
        let parsed = { rows: [], errors: [] }
        if (name.endsWith('.xlsx')) {
          const buf = await this.readFileAsArrayBuffer(file)
          parsed = this.parseXlsx(buf)
        } else {
          const text = await this.readFileAsText(file)
          parsed = this.parseCsv(text)
        }
        const { rows, errors } = parsed
        this.importRows = rows
        this.importErrors = errors
      } catch (e) {
        this.$message.error('解析文件失败')
      }
    },
    readFileAsText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(String(reader.result || ''))
        reader.onerror = () => reject(new Error('read failed'))
        reader.readAsText(file, 'utf-8')
      })
    },
    readFileAsArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = () => reject(new Error('read failed'))
        reader.readAsArrayBuffer(file)
      })
    },
    parseXlsx(buffer) {
      const wb = XLSX.read(buffer, { type: 'array' })
      const names = (wb && wb.SheetNames) || []
      const sheetName =
        names.find(n => String(n || '').trim() === 'points_import') ||
        names[0] ||
        ''
      if (!sheetName) return { rows: [], errors: [{ line: 1, msg: 'Excel 文件为空' }] }
      const ws = wb.Sheets[sheetName]
      const aoa = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' })
      const matrix = (Array.isArray(aoa) ? aoa : [])
        .map(row => (Array.isArray(row) ? row.map(x => String(x == null ? '' : x)) : []))
        .filter(row => row.some(cell => String(cell || '').trim() !== ''))
      if (!matrix.length) return { rows: [], errors: [{ line: 1, msg: 'Excel 文件为空' }] }
      return this.parseTableMatrix(matrix)
    },
    /** 非负整数：兼容 Excel 数字 100、字符串 "100.0"、千分位 */
    isNonNegIntCell(v) {
      if (v == null || String(v).trim() === '') return true
      const n = Number(String(v).trim().replace(/,/g, ''))
      return Number.isFinite(n) && n >= 0 && Number.isInteger(n)
    },
    /**
     * RFC4180 风格 CSV：引号字段内可有换行、逗号。
     */
    parseCsvRowsToTable(text) {
      let s = String(text || '').replace(/^\uFEFF/, '')
      s = s.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
      const out = []
      let row = []
      let field = ''
      let inQuotes = false
      for (let i = 0; i < s.length; i++) {
        const c = s[i]
        if (inQuotes) {
          if (c === '"') {
            if (i + 1 < s.length && s[i + 1] === '"') {
              field += '"'
              i++
            } else {
              inQuotes = false
            }
          } else {
            field += c
          }
          continue
        }
        if (c === '"') {
          inQuotes = true
          continue
        }
        if (c === ',') {
          row.push(field)
          field = ''
          continue
        }
        if (c === '\n') {
          row.push(field)
          field = ''
          out.push(row)
          row = []
          continue
        }
        field += c
      }
      row.push(field)
      out.push(row)
      return out.filter(r => r.some(cell => String(cell || '').trim() !== ''))
    },
    parseTableMatrix(matrix) {
      const lines = (Array.isArray(matrix) ? matrix : [])
        .map(row => (Array.isArray(row) ? row.map(x => String(x == null ? '' : x).trim()) : []))
        .filter(row => row.some(cell => String(cell || '').trim() !== ''))
      if (!lines.length) return { rows: [], errors: [{ line: 1, msg: '空文件' }] }

      const header = lines[0]
      const idx = (k) => header.indexOf(k)
      const needAnyKey = idx('id') >= 0 || idx('phone') >= 0 || idx('licensePlate') >= 0
      if (!needAnyKey) {
        return { rows: [], errors: [{ line: 1, msg: '缺少表头：需要包含 id / phone / licensePlate 之一' }] }
      }
      const hasLegacyPoints = idx('points') >= 0
      const incCol = idx('increasePoints') >= 0 ? idx('increasePoints') : idx('increase')
      const decCol = idx('decreasePoints') >= 0 ? idx('decreasePoints') : idx('decrease')
      const hasIncrease = incCol >= 0
      const hasDecrease = decCol >= 0
      const hasFinal = idx('finalPoints') >= 0
      const hasCurrent = idx('currentPoints') >= 0
      if (!hasLegacyPoints && !hasIncrease && !hasDecrease && !hasFinal && !hasCurrent) {
        return { rows: [], errors: [{ line: 1, msg: '缺少积分相关列：currentPoints / points / increase(Points) / decrease(Points) / finalPoints' }] }
      }

      const rows = []
      const errors = []
      const cellAt = (cols, j) => (j >= 0 && j < cols.length ? cols[j] : '')

      for (let i = 1; i < lines.length; i++) {
        const lineNo = i + 1
        const cols = lines[i]
        const row = {
          id: idx('id') >= 0 ? cellAt(cols, idx('id')) : '',
          phone: idx('phone') >= 0 ? cellAt(cols, idx('phone')) : '',
          licensePlate: idx('licensePlate') >= 0 ? cellAt(cols, idx('licensePlate')) : '',
          points: hasLegacyPoints ? cellAt(cols, idx('points')) : '',
          increasePoints: hasIncrease ? cellAt(cols, incCol) : '',
          decreasePoints: hasDecrease ? cellAt(cols, decCol) : '',
          finalPoints: hasFinal ? cellAt(cols, idx('finalPoints')) : '',
          currentPoints: hasCurrent ? cellAt(cols, idx('currentPoints')) : ''
        }
        if (!row.id && !row.phone && !row.licensePlate) {
          errors.push({ line: lineNo, msg: '缺少定位字段：id/phone/licensePlate' })
          continue
        }
        const hasAnyValue =
          !!String(row.finalPoints || '').trim() ||
          !!String(row.points || '').trim() ||
          !!String(row.increasePoints || '').trim() ||
          !!String(row.decreasePoints || '').trim() ||
          !!String(row.currentPoints || '').trim()
        if (!hasAnyValue) {
          errors.push({ line: lineNo, msg: '缺少积分值：请填写 currentPoints / finalPoints / points 或 增减列' })
          continue
        }
        if (String(row.finalPoints || '').trim() && !this.isNonNegIntCell(row.finalPoints)) {
          errors.push({ line: lineNo, msg: 'finalPoints 必须为非负整数' })
          continue
        }
        if (!String(row.finalPoints || '').trim() && String(row.points || '').trim() && !this.isNonNegIntCell(row.points)) {
          errors.push({ line: lineNo, msg: 'points 必须为非负整数' })
          continue
        }
        if (String(row.increasePoints || '').trim() && !this.isNonNegIntCell(row.increasePoints)) {
          errors.push({ line: lineNo, msg: 'increase / increasePoints 必须为非负整数' })
          continue
        }
        if (String(row.decreasePoints || '').trim() && !this.isNonNegIntCell(row.decreasePoints)) {
          errors.push({ line: lineNo, msg: 'decrease / decreasePoints 必须为非负整数' })
          continue
        }
        if (String(row.currentPoints || '').trim() && !this.isNonNegIntCell(row.currentPoints)) {
          errors.push({ line: lineNo, msg: 'currentPoints 必须为非负整数' })
          continue
        }
        rows.push(row)
      }
      return { rows, errors }
    },
    parseCsv(text) {
      const matrix = this.parseCsvRowsToTable(text)
      return this.parseTableMatrix(matrix)
    },
    resolveImportMatch(row) {
      const id = String(row.id || '').trim()
      const phone = String(row.phone || '').trim()
      const plate = String(row.licensePlate || '').trim()
      if (id) return { type: 'id', value: id }
      if (phone) return { type: 'phone', value: phone }
      if (plate) return { type: 'licensePlate', value: plate }
      return null
    },
    async findUserIdByMatch(match) {
      if (!match) return null
      if (match.type === 'id') return String(match.value)
      const q = {
        phone: '',
        licensePlate: '',
        level: '',
        page: 1,
        pageSize: 10
      }
      if (match.type === 'phone') q.phone = match.value
      if (match.type === 'licensePlate') q.licensePlate = match.value
      const res = await request.get('/users', { params: q })
      const data = res.data || res
      const items = (data && data.items) || []
      if (!items.length) return null
      // 命中多条时取第一条，并在结果里提示
      return items[0] && items[0].id != null ? String(items[0].id) : null
    },
    async runImport() {
      if (this.importErrors.length) {
        this.$message.warning('请先修复 CSV 解析错误后再导入')
        return
      }
      if (!this.importRows.length) return

      this.importing = true
      this.importProgress = 0
      this.importResultLines = []

      const total = this.importRows.length
      let ok = 0
      let fail = 0

      try {
        for (let i = 0; i < total; i++) {
          const r = this.importRows[i]
          const match = this.resolveImportMatch(r)
          // eslint-disable-next-line no-await-in-loop
          const userId = await this.findUserIdByMatch(match)
          if (!userId) {
            fail += 1
            this.importResultLines.push(`第${i + 1}行：未找到用户（${match ? match.type : ''}:${match ? match.value : ''}）`)
            this.importProgress = Math.floor(((i + 1) / total) * 100)
            continue
          }

          const fp = String(r.finalPoints || '').trim()
          const pLegacy = String(r.points || '').trim()
          const inc = String(r.increasePoints || '').trim()
          const dec = String(r.decreasePoints || '').trim()
          const cp = String(r.currentPoints || '').trim()
          const toInt = (s) => {
            const n = Number(String(s).replace(/,/g, ''))
            if (!Number.isFinite(n) || n < 0 || !Number.isInteger(n)) return null
            return n
          }
          let payload = null
          if (fp) {
            const n = toInt(fp)
            if (n == null) {
              fail += 1
              this.importResultLines.push(`第${i + 1}行：finalPoints 需为非负整数`)
              this.importProgress = Math.floor(((i + 1) / total) * 100)
              continue
            }
            payload = { points: n }
          } else if (pLegacy) {
            const n = toInt(pLegacy)
            if (n == null) {
              fail += 1
              this.importResultLines.push(`第${i + 1}行：points 需为非负整数`)
              this.importProgress = Math.floor(((i + 1) / total) * 100)
              continue
            }
            payload = { points: n }
          } else if (inc !== '' || dec !== '') {
            const addVal = inc !== '' ? toInt(inc) : 0
            const subVal = dec !== '' ? toInt(dec) : 0
            if (addVal == null || subVal == null) {
              fail += 1
              this.importResultLines.push(`第${i + 1}行：增减积分需为非负整数`)
              this.importProgress = Math.floor(((i + 1) / total) * 100)
              continue
            }
            if (addVal <= 0 && subVal <= 0) {
              fail += 1
              this.importResultLines.push(`第${i + 1}行：请填写大于 0 的 increase 或 decrease，或其它积分列`)
              this.importProgress = Math.floor(((i + 1) / total) * 100)
              continue
            }
            payload = { delta: addVal - subVal }
          } else if (cp) {
            const n = toInt(cp)
            if (n == null) {
              fail += 1
              this.importResultLines.push(`第${i + 1}行：currentPoints 需为非负整数`)
              this.importProgress = Math.floor(((i + 1) / total) * 100)
              continue
            }
            payload = { points: n }
          } else {
            fail += 1
            this.importResultLines.push(`第${i + 1}行：无有效积分列`)
            this.importProgress = Math.floor(((i + 1) / total) * 100)
            continue
          }

          try {
            // eslint-disable-next-line no-await-in-loop
            await request.put(`/users/${userId}/points`, payload)
            ok += 1
            this.importResultLines.push(`第${i + 1}行：成功（userId=${userId}）`)
          } catch (e) {
            fail += 1
            this.importResultLines.push(`第${i + 1}行：失败（userId=${userId}）`)
          }

          this.importProgress = Math.floor(((i + 1) / total) * 100)
        }
      } finally {
        this.importing = false
        this.importProgress = 100
        this.$message.success(`导入完成：成功 ${ok}，失败 ${fail}`)
        this.fetchList()
      }
    }
  }
}
</script>

